<template>
  <v-row class="px-4 pb-2">
    <v-col class="py-0" cols="4">
      <v-autocomplete
        hide-details
        :items="duaMiscCodesParsed"
        label="Övrigt"
        item-value="code"
        item-text="_text"
        v-model="dua_misc_code"
        :disabled="isHistoryEvent"
        :append-icon="
          isDiff('dua_misc_code') ? 'mdi-alert-octagram' : 'mdi-menu-down'
        "
        clearable
      />
    </v-col>
    <template v-if="dua_misc_code">
      <v-col v-for="(param, $i) in parameters" :key="$i" class="py-0">
        <v-autocomplete
          :items="stops"
          :rules="[required]"
          :disabled="isHistoryEvent"
          item-value="short_name"
          :item-text="item => `(${item.short_name}) ${item.stop_name}`"
          :filter="
            (item, query) =>
              item.short_name.toLowerCase().includes(query.toLowerCase()) ||
              item.stop_name.toLowerCase().includes(query.toLowerCase())
          "
          :label="`Station ${$i + 1}`"
          :append-icon="
            isDiffParameters ? 'mdi-alert-octagram' : 'mdi-menu-down'
          "
          :value="param.value"
          @input="value => onParamInput($i, value)"
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import gql from 'graphql-tag'
import { required } from '@/common/validationRules'
import { get } from 'vuex-pathify'

const getSet = prop => ({
  get() {
    return this.form[this.uuid].data[prop] || null
  },

  set(v) {
    const form = Object.assign({}, this.form)
    let value = v

    if ((!value || !value.length) && !Array.isArray(value)) {
      value = null
    }
    form[this.uuid].data[prop] = value
    this.$store.set('duaMessage/form', form)
  }
})

export default {
  name: 'DuaMessageMiscFields',

  props: {
    deviationType: String,
    uuid: String
  },

  data: () => ({
    required
  }),

  apollo: {
    duaMiscCodes: {
      query: gql`
        query duaMiscCodes {
          duaMiscCodes {
            code
            text
            not_valid_when_canceled
            parameters {
              property
            }
          }
        }
      `
    }
  },

  watch: {
    dua_misc_code: {
      handler(value) {
        const form = Object.assign({}, this.form)
        if (value) {
          form[this.uuid].data.parameters = this.duaMiscParameters.map(
            ({ property }) => ({
              property,
              value: null
            })
          )
        } else {
          form[this.uuid].data.parameters = null
        }

        this.$store.set('duaMessage/form', form)
      }
    }
  },

  computed: {
    model: get('duaMessage/model'),
    form: get('duaMessage/form'),
    stops: get('event/stops'),
    isHistoryEvent: get('history/isHistoryEvent'),

    currentTrip() {
      return this.model.body.find(x => x.trip_uuid === this.uuid)
    },

    dua_misc_code: {
      ...getSet('dua_misc_code')
    },

    parameters: {
      ...getSet('parameters')
    },

    duaMiscParameters() {
      if (!this.dua_misc_code || !this.duaMiscCodes) return
      return this.duaMiscCodes.find(x => x.code === this.dua_misc_code)
        .parameters
    },
    duaMiscCodesParsed() {
      return (this.duaMiscCodes || [])
        .filter(x =>
          x.not_valid_when_canceled
            ? !['CANCELED', 'PARTIAL_CANCELLATION'].includes(this.deviationType)
            : true
        )
        .map(x => ({
          ...x,
          _text: x.text.split('{')[0]
        }))
    },

    isDiffParameters() {
      return (
        this.currentTrip &&
        JSON.stringify(this.currentTrip.data.parameters || null) !==
          JSON.stringify(this.form[this.uuid].data.parameters || null)
      )
    }
  },

  methods: {
    onParamInput(index, value) {
      const form = Object.assign({}, this.form)
      const parameters = this.form[this.uuid].data.parameters.map(x => ({
        ...x
      }))

      parameters[index].value = value

      form[this.uuid].data.parameters = parameters
      this.$store.set('duaMessage/form', form)
    },

    isDiff(prop) {
      return (
        this.currentTrip &&
        (this.currentTrip.data[prop] || null) !==
          (this.form[this.uuid].data[prop] || null)
      )
    }
  }
}
</script>
